import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import sup_haz_lev from "../img/sswpIcons/Supervision/sup_haz_lev.png";
import sup_can from "../img/sswpIcons/Supervision/sup_can.png";
import sup_com_ind from "../img/sswpIcons/Supervision/sup_com_ind.png";
import sup_cscs from "../img/sswpIcons/Supervision/sup_csc.png";
import sup_dri_wat from "../img/sswpIcons/Supervision/sup_dri_wat.png";
import sup_dry_cha from "../img/sswpIcons/Supervision/sup_dry_cha.png";
import sup_fir_aid from "../img/sswpIcons/Supervision/sup_fir_aid.png";
import sup_pla_eq_cert from "../img/sswpIcons/Supervision/sup_pla_equ.png";
import sup_ppe from "../img/sswpIcons/Supervision/sup_ppe.png";
import sup_saf_pas from "../img/sswpIcons/Supervision/sup_saf_pas.png";
import sup_wc_and_was from "../img/sswpIcons/Supervision/sup_wc_was.png";
import sup_smo_con from "../img/sswpIcons/Supervision/sup_smo_con.png";
import sup_sit_spe_met_sta from "../img/sswpIcons/Supervision/sup_sit_spe_met.png";
const json = {
    icon: sup_haz_lev,
    name: "Supervision/ Before Beginning",
    text: (
        <Typography variant="title">
            Every activity must be initiated and controlled. Supervision,
            generally by the person in charge, e.g. the foreman, is essential to
            ensure the activity is completed as planned, and to ensure a safe
            system of work.
        </Typography>
    ),
    icons: {
        sup_saf_pas: {
            name: "Safe Pass",
            icon: sup_saf_pas,
            text: (
                <ul>
                    <ListItem text="All people engaged in construction must possess an in-date safe pass card issued by Solas, and have it with them on-site." />
                </ul>
            )
        },
        sup_pla_equ: {
            name: "Plant/ EQ Cert",
            icon: sup_pla_eq_cert,
            text: (
                <ul>
                    <ListItem text="Before any plant or equipment should not be commissioned for use until it has been inspected by a competent person." />
                    <Li>
                        <Typography variant="title">
                            The following is a non-exhaustive list of prescribed
                            thorough examination periods for various items
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Item</th>
                                    <th>GA1: Thorough examination period</th>
                                </tr>
                                <tr>
                                    <td>Hoist or Lift</td>
                                    <td>6 Months</td>
                                </tr>
                                <tr>
                                    <td>Tailboard goods Lift</td>
                                    <td>12 Months</td>
                                </tr>
                                <tr>
                                    <td>Suspended access equipment</td>
                                    <td>6 Months</td>
                                </tr>
                                <tr>
                                    <td>Mast climbing work platform</td>
                                    <td>6 Months</td>
                                </tr>
                                <tr>
                                    <td>
                                        Lifting accessories (slings, chains,
                                        ropes, hooks, etc)
                                    </td>
                                    <td>6 Months</td>
                                </tr>
                                <tr>
                                    <td>Support items for lifting equipment</td>
                                    <td>12 Months</td>
                                </tr>
                                <tr>
                                    <td>MEWPs</td>
                                    <td>6 Months</td>
                                </tr>
                                <tr>
                                    <td>Crane</td>
                                    <td>12 Months</td>
                                </tr>
                                <tr>
                                    <td>Tower crane climbing rig</td>
                                    <td>6 Months</td>
                                </tr>
                                <tr>
                                    <td>Forklift and accessories</td>
                                    <td>12 Months</td>
                                </tr>
                                <tr>
                                    <td>Telehandler and accessories</td>
                                    <td>12 Months</td>
                                </tr>
                                <tr>
                                    <td>Winches</td>
                                    <td>12 Months</td>
                                </tr>
                                <tr>
                                    <td>
                                        Operative lifting plant/equipment (will
                                        include plant used for man-cradles)
                                    </td>
                                    <td>6 Months</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Plant and equipment also needs ongoing monitoring
                            inspections for maintenance and wear. The following
                            is a non-exhaustive list of such inspections
                        </Typography>

                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>Lifting equipment</td>
                                    <td>GA2: Weekly Inspection</td>
                                </tr>
                                <tr>
                                    <td>Working at height equipment</td>
                                    <td>
                                        GA3: Work equipment for working at
                                        height
                                    </td>
                                </tr>
                                <tr>
                                    <td>Plant/ Vehicles</td>
                                    <td>Daily walk around inspection</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        sup_csc: {
            name: "CSCS",
            icon: sup_cscs,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            The following tasks require CSCS cards
                        </Typography>
                        <ol>
                            <Li>Scaffolding (Basic, Advanced, Mobile Tower)</Li>
                            <Li>
                                Crane Operation (Tower, Self erecting tower,
                                mobile, and crawler)
                            </Li>
                            <Li>Slinging/ Signalling</Li>
                            <Li>Tractor/ Dozer Operator</Li>
                            <Li>Articulated Dumper driver</Li>
                            <Li>Site Dumper driver</Li>
                            <Li>Telescopic Handler</Li>
                            <Li>Excavator (360, 180 and mini digger)</Li>
                            <Li>Roof and wall cladding/ sheeting</Li>
                            <Li>
                                Built-up roof felting (bituminous, and single
                                ply)
                            </Li>
                            <Li>Signing, Lighting and Guarding at Roadworks</Li>
                            <Li>Assisting in health and safety at roadworks</Li>
                            <Li>Location of underground services</Li>
                            <Li>Shotfiring</Li>
                        </ol>
                    </Li>{" "}
                </ul>
            )
        },
        sup_com_ind: {
            name: "Communication/ Induction",
            icon: sup_com_ind,
            text: (
                <ul>
                    <ListItem
                        text="  All new employees/ contractors entering a site
                            should undergo an induction."
                    />

                    <Li>
                        <Typography variant="title">
                            The induction should cover the following topics
                        </Typography>
                        <ol>
                            <Li>Site rules and procedures</Li>
                            <Li>Arrangements for safety and welfare</Li>
                            <Li>Key responsible people</Li>
                            <Li>Emergency plans/ procedures</Li>
                            <Li>
                                Requirements for PPE (as per tasks to be
                                undertaken)
                            </Li>
                        </ol>
                    </Li>
                    <ListItem
                        text="The completion of this SSWP may be used as part of
                            the induction"
                    />
                    <ListItem
                        text="   If the site, works, or hazards present change, then
                            operatives should be re-inducted."
                    />
                </ul>
            )
        },
        sup_wc_was: {
            name: "WC & Washing",
            icon: sup_wc_and_was,
            text: (
                <ul>
                    <ListItem text="Access to toilets and hand-washing facilities must be provided on all sites. It must be conveniently accessible and kept clean and hygienic, and be adequately ventilated." />
                    <ListItem text="A urinal only convenience does NOT meet this requirement." />
                    <ListItem text="The facility must have hot and cold running water, toilet tissue, soap and clean towels, and be adequately lit." />
                    <ListItem text="If there are dangerous substances on site there must be an adequate number of nail brushes and at least one trough, basin, or washbasin, as may be appropriate, for every 5 persons at work. " />
                    <Li>
                        <Typography variant="title">
                            If the work > 30 days on site, the following is
                            required on site
                        </Typography>
                        <ol>
                            <ListItem text="adequate troughs or basins with smooth impermeable internal surfaces" />
                            <ListItem text="an adequate means of cleaning and drying such as soap and clean towels " />
                            <ListItem text="a sufficient supply of running hot and cold or warm water, hot water temperatures must be controlled so as to prevent scalding " />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            If > 100 persons at work, or if > 12 months, the
                            following is required
                        </Typography>
                        <ol>
                            <ListItem text="Six washbasins plus the addition of one for each group of 20 persons exceeding 100. " />
                        </ol>
                    </Li>
                    <ListItem text="the washing facilities must have suitable accessibility from any accommodation provided for taking meals " />
                    <ListItem text="separate washbasins are provided for men and women where appropriate; " />
                    <ListItem text="If required by the nature of the work or for health reasons suitable showers shall be provided and provision is made for separate shower rooms or separate use of shower rooms for both men and women;  " />
                    <ListItem text="the shower rooms are sufficiently large enough, hygienic and equipped with hot and cold running water to allow each person to wash themselves effectively; and " />
                    <ListItem text="where the rooms housing the showers or washbasins are separate from the changing rooms ensure there is easy acessibility between them. " />
                    <ListItem text="at least one toilet convenience must be provided for every 20 persons at work on the site (urinal only does NOT meet this requirement); " />
                    <ListItem text="If there are more than 100 persons at work on a site and sufficient urinal accommodation is also provided, it shall be sufficient that one such convenience is provided for every 25 persons up to the first 100 and an additional one provided for every 35 persons thereafter;" />
                    <ListItem text="where practicable conveniences should discharge into a main sewer," />
                    <ListItem text="the convenience must be partitioned off to secure privacy, have a proper door and fastening; " />
                    <ListItem text="the convenience must be easily accessible to persons at work at all times while they are at the site and where possible is convenient to the washing facilities; and" />
                    <ListItem text="provision shall be made for separate use of sanitary convenience for men and women." />
                </ul>
            )
        },

        sup_can: {
            name: "Canteen",
            icon: sup_can,
            text: (
                <ul>
                    <ListItem
                        text="To be provided at or in the immediate vicinity
                                of the site"
                    />
                    <ListItem
                        text="Properly ventilated, adequately lit, kept clean,
                                hygienic and orderly condition. Not to be used
                                for the deposit or storage of materials,
                                equipment or plant."
                    />
                    <ListItem
                        text="   Suitable enclosed accommodation for shelter,
                                with sufficient table with impermeable surfaces
                                and seats with backs for taking meals."
                    />
                    <ListItem text="Adequate supply of drinkable water" />
                    <ListItem text="Facilities for boiling water." />
                    <ListItem
                        text="Where appropriate facilities for preparing meals
                                in satisfactory conditions. Where there are > 5
                                persons on site (and heated food not otherwise
                                available) adequate facilities for heating food."
                    />
                </ul>
            )
        },
        sup_dry_cha: {
            name: "Drying/ Changing",
            icon: sup_dry_cha,
            text: (
                <ul>
                    <ListItem text="To be provided at or in the immediate vicinity of the site" />
                    <ListItem text="Properly ventilated, adequately lit, kept clean, hygienic and orderly condition. " />
                    <ListItem text="For sites > 5 persons, adequate means for operatives to warm themselves and drying of wet clothing." />
                    <ListItem text="For sites < 5 persons, arrangements for operatives to warm themselves and drying of wet clothing." />
                    <ListItem text="Adequate accommodation at, or in the immediate vicinity of,  for the deposit of protective clothing when not in use. Practical arrangements for drying if clothing becomes wet." />
                    <ListItem text="Changing rooms should be easily accessible, sufficient capacity and provided with seating. If work clothes are likely to be contaminated by dangerous substances, they should be kept separate from personal clothing." />
                    <ListItem text="If changing rooms are not required, then secure lockers must be provided for personal clothes and personal belongings." />
                </ul>
            )
        },
        sup_dri_wat: {
            name: "Drinking Water",
            icon: sup_dri_wat,
            text: (
                <ul>
                    <ListItem text="An adequate supply of wholesome drinking water must be provided at a convenient point(s)." />
                </ul>
            )
        },

        sup_fir_aid: {
            name: "First Aid",
            icon: sup_fir_aid,
            text: (
                <ul>
                    <ListItem text="First Aid equipment must be provided at each site, be suitably marked and easily accessible." />
                    <Li>
                        <Typography variant="title">
                            All operatives on site must know the location of the
                            first aid equipment. The recommended minimum
                            contents (to be regularly checked) are
                        </Typography>
                        <StyledTable
                            style={{
                                border: "1px solid black",
                                marginTop: 15,
                                padding: 10
                            }}
                        >
                            <tbody>
                                <tr>
                                    <th />
                                    <th />
                                    <th colSpan="3">Staff On Site</th>
                                </tr>
                                <tr>
                                    <th />
                                    <th>Mobile</th>
                                    <th>1-10</th>
                                    <th>11-25</th>
                                    <th>26-50</th>
                                </tr>

                                <tr>
                                    <td>Adhesive plasters</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>20</td>
                                </tr>
                                <tr>
                                    <td>Sterile eye pads</td>
                                    <td>2</td>
                                    <td>2</td>
                                    <td>2</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>Triangular bandages</td>
                                    <td>2</td>
                                    <td>2</td>
                                    <td>6</td>
                                    <td>6</td>
                                </tr>
                                <tr>
                                    <td>Safety pins</td>
                                    <td>6</td>
                                    <td>6</td>
                                    <td>6</td>
                                    <td>6</td>
                                </tr>
                                <tr>
                                    <td>Sterile wound dressing (medium)</td>
                                    <td>1</td>
                                    <td>2</td>
                                    <td>2</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>Sterile wound dressing (large)</td>
                                    <td>1</td>
                                    <td>2</td>
                                    <td>6</td>
                                    <td>8</td>
                                </tr>
                                <tr>
                                    <td>
                                        Sterile wound dressing (extra large)
                                    </td>
                                    <td>1</td>
                                    <td>2</td>
                                    <td>3</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>Disinfectant wipes</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>20</td>
                                    <td>40</td>
                                </tr>
                                <tr>
                                    <td>Shears</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>Gloves</td>
                                    <td>3</td>
                                    <td>5</td>
                                    <td>10</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>Sterile Water</td>
                                    <td>2x 20ml</td>
                                    <td>1x 500ml</td>
                                    <td>2x 500ml</td>
                                    <td>2x 500ml</td>
                                </tr>
                                <tr>
                                    <td>Face Mask</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>Burn dressing (small)</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>Burn dressing (large)</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>Crepe bandage (small)</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>2</td>
                                    <td>3</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            The number of occupational first aiders required at
                            each place of work is{" "}
                        </Typography>
                        <ol>
                            <Li>
                                Up to 49 staff = 1 First Aider dependant on Risk
                                Assessment, and in accordance with your safety
                                management system.
                            </Li>
                            <Li>50-149 staff = Minimim of 1 First Aider</Li>
                            <Li>150-299 = Minimum of 2 First Aider</Li>
                            <Li>>300 = 1 extra for each 150 staff.</Li>
                        </ol>
                    </Li>
                </ul>
            )
        },

        sup_ppe: {
            name: "PPE",
            icon: sup_ppe,
            text: (
                <ul>
                    <ListItem text="PPE should never be used as a control measure by itself. First risk management controls need to be used, such as technical measures or work organisation methods. You should have a method statement that outlines the chosen method, and have adequate training and knowledge on what is to be done." />
                    <ListItem text="PPE is the last line of defense to protect you from physical harm" />
                    <ListItem text="The PPE required for your task should be specifically identified in the relevant sections of this form." />
                </ul>
            )
        },
        sup_smo_con: {
            name: "Smoking Control",
            icon: sup_smo_con,
            text: (
                <ul>
                    <ListItem text="Smoking is prohibited in enclosed work places" />
                    <ListItem text="Smoking is prohibited when handling substances or chemicals." />
                </ul>
            )
        },
        sup_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: sup_sit_spe_met_sta,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
